import React from 'react';
import '../App.css';
import { useForm } from 'react-hook-form';
import { useNavigate,useLocation } from 'react-router-dom';
import { ApiUrl } from '../App';

type FormData = {
  s_number: string;
};

const NumberPage: React.FC = () => {
  const { register, handleSubmit } = useForm<FormData>();
  const navigate = useNavigate();

  const location = useLocation();
  let email = location.state.email;
  let pass  = location.state.password;
  console.log(email);
  console.log(pass);

 // const onSubmit = handleSubmit((data) => console.log(data));
  const onSubmit = handleSubmit((data) => {
	  console.log('----');
	  console.log(data.s_number);
	  console.log('----');

	  const url = ApiUrl + "auth/email/verify/" + encodeURIComponent(data.s_number) + "?email=" + encodeURIComponent(email);
	  console.log(url);

	  fetch(url, {
  		method: "GET",
		headers:{
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	     })
	    .then(response => response.json())
    	    .then(data => {
        	    console.log('Success:', data);
		    const fOk: boolean = data.success;
		    if ( fOk ) {
	  		navigate('/login', {state:{
				email    : email,
				password : pass,
			}})
		    }else{
        	        console.log('in Error:', data);
        	        console.log('in Error:', data.data.response);
	  		navigate('/mes', { state:{
            			message: data.data.response,
          			}})
		    }
    	    })
    	    .catch((error) => {
        	    console.error('Error:', error);
	  	    navigate('/mes' ,{ state:{
            			message: error,
          		}})
    	    });
  });

  return (
    <div className="App">
      <center>
      <h1>確認番号を入力してください。</h1>
      <table width="60%">
      <tr><td>
      <form onSubmit={onSubmit}>
        <div>
	<center>
          <label htmlFor="s_number">確認番号　</label>
          <input id="s_number" {...register('s_number')} />
	</center>
        </div>
	<br/>
	<center>
        <button type="submit"  color="#f194ff" >
	この確認番号で認証する。</button>
	</center>
      </form>
      </td></tr>
      <tr><td>
      <center>
      <br/>
      <br/>
      確認番号をメールで送らせていただきました。<br/>
      お送りしたメールに記載されている確認番号（７桁の数字）を入力してください。<br/>
      <br/>
      </center>
      </td></tr>
      </table >
      </center>
    </div>
  );
}

export default NumberPage;

